import './style.scss';

import SingleButton, { getClassName, getDisabledClassName } from '@/components/SingleButton';
import { TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { inject, observer } from 'mobx-react';

import Msg from '@/components/Msg';
import React from 'react';
import classnames from 'classnames';
import { getContent } from '@/utils/tools';
import { handleOptionBtnClick } from '@/utils/btnClickHandler';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';

const PREFIX = 'options-container';
@tracker
@inject(getChildInject('initStore'))
@observer
export default class Options extends React.PureComponent {
  static defaultProps = {
    // props
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    msgContent: '',
    options: []
  };

  constructor(props) {
    super(props);

    const {
      dialogueId, nodePointId, initStore, isHistory,
      historyDialogueId, historySessionId,
    } = this.props;
    const { sessionId } = initStore;

    this.trackingname = TRACKING_TYPE.STANDARDIZE_BUTTON;
    this.trackingdata = {
      chat_session_id: isHistory ? historySessionId : (sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      node_point_id: nodePointId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME
    };
  }

  getTrackingData = (option) => {
    const { button_id = '', button_type = '' } = option;

    return {
      button_text: getContent(option),
      button_id, button_type
    };
  };

  handleOptionClick = (option) => () => {
    const { dialogueId, dialogueType, context, isHistory, customCallback = {} } = this.props;

    const trackingdata = {
      ...this.trackingdata,
      ...this.getTrackingData(option)
    };

    handleOptionBtnClick(
      {
        ...option,
        isHistory
      },
      {
        dialogueId,
        dialogueType,
        context
      },
      {
        trackingname: this.trackingname,
        trackingdata
      },
      customCallback,
    );
  };

  generateOption = (option, index) => {
    const { passedRef } = this.props;
    const { disabledBtn } = option;

    const trackingdata = JSON.stringify({
      ...this.trackingdata,
      button_details: [{ ...this.getTrackingData(option) }],
    });
    const className = disabledBtn ? getDisabledClassName(option.style) : getClassName(option.style);
    const props = {
      className: classnames('option-container', className),
      key: `option-${index}`,
      text: getContent(option),
      handleClick: this.handleOptionClick(option),
      trackingname: this.trackingname,
      trackingdata,
      passedRef: (ele) => passedRef(ele, index),
      disabled: disabledBtn
    };

    return <SingleButton {...props} />;
  };

  render() {
    const { msgContent, options, isDisabled, type } = this.props;

    return (
      <div className={classnames(PREFIX, { horizontal: type === 'horizontal' }, 'chatbot-option-container')}>
        <Msg content={msgContent} />
        {isDisabled ? null : (
          <div className="options">
            {options.map((option, index) => {
              return this.generateOption(option, index);
            })}
          </div>
        )}
      </div>
    );
  }
}
